import WorkCycleTableContainer from './WorkCycleTableContainer';

export default WorkCycleTableContainer;